import React from 'react';
import routes from '@configs/routes.json';
import { trimLeadingSlashes } from '@utils/urlUtils';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@store/reducer';
import { useTranslation } from 'react-i18next';
export interface IBreadcrumbProps {
  relativePath: string;
}
interface LinkProps {
  text: string;
  url: string;
}
export const FilesBreadcrumb: React.FC<IBreadcrumbProps> = ({
  relativePath,
}) => {
  const activeProjectId = useSelector(
    (state: IApplicationState) => state.projectPicker.activeProjectId
  );
  const { t } = useTranslation();
  const getUrls = (): LinkProps[] => {
    let urls: LinkProps[] = [
      { text: t('files_allFiles'), url: routes.app.files },
    ];
    if (relativePath.length > 0 && activeProjectId) {
      let folders = relativePath.split('/');
      folders.forEach((folder: string, index: number) => {
        let currentRelativePath = folders.slice(0, index + 1).join('/');
        let url = routes.app.filesHierarchy.replace(
          ':relativePath+',
          trimLeadingSlashes(currentRelativePath)
        );
        urls.push({ text: folder, url: url });
      });
    }
    return urls;
  };
  const [crumbs] = React.useState(getUrls());

  return (
    <div className='breadcrumb mb-2'>
      {crumbs.map((crumb, index) => {
        if (index + 1 === crumbs.length) {
          return (
            <div className={'breadcrumb-item active'} key={index}>
              <span>{crumb.text}</span>
            </div>
          );
        } else {
          return (
            <React.Fragment>
              <Link to={crumb.url} className={'breadcrumb-item'} key={index}>
                <span>{crumb.text}</span>
              </Link>
              <i className='fas fa-chevron-right'></i>
            </React.Fragment>
          );
        }
      })}
    </div>
  );
};
